import { TabContext } from "@mui/lab";
import {
  Box,
  Button,
  Grid,
  Typography,
  TextField,
  FormControl,
} from "@mui/material";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { back } from "../iconsImports";
import { postJsonData } from "../network/ApiController"; // Same as MobileRechargeForm
import Swal from "sweetalert2";
import ApiEndpoints from "../network/ApiEndPoints";
import { apiErrorToast, okSuccessToast } from "../utils/ToastUtil";
import { error } from "jquery";

const PgOrder = ({ resetView }) => {
  const { tripType } = useSelector((state) => state?.flight);
  const [isLoading, setIsLoading] = useState(false);
  const [amount, setAmount] = useState("");

  const handleBack = () => {
    resetView(false);
  };

  const handleCreatePg = () => {
    if (!amount || isNaN(amount) || Number(amount) <= 0) {
      Swal.fire({
        icon: "error",
        title: "Invalid Amount",
        text: "Please enter a valid amount",
      });
      return;
    }

    const payload = {
      amount: Number(amount), // include amount in payload
    };

    postJsonData(
      ApiEndpoints.CREATE_PG,
      payload,
      setIsLoading,
      (res) => {
        if (res) {
          okSuccessToast(
            res.data.response.message || "Redirecting to payment..."
          );
          // Redirect to the payment link
          window.open(res.data.response.link, "_blank", "noopener,noreferrer");
        } else {
          apiErrorToast("Payment initiation failed");
        }
      },
      (error) => {
        console.error("API Error:", error);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed to initiate Payment Gateway",
        });
      }
    );
  };

  return (
    <TabContext value={tripType || ""}>
      <Box
        sx={{
          height: "80vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          p: 3,
          textAlign: "center",
        }}
      >
        {/* 🔹 Text Above Amount */}
        <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
          Enter Amount
        </Typography>

        {/* 🔹 Amount Field */}
        <FormControl sx={{ width: "300px", mb: 3 }}>
          <TextField
            label="Amount"
            type="number"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            inputProps={{ min: 1 }}
            fullWidth
            size="small"
          />
        </FormControl>

        {/* 🔹 Create PG Button BELOW Amount */}
        <Button
          variant="contained"
          onClick={handleCreatePg}
          disabled={isLoading}
          sx={{ width: "300px" }}
        >
          {isLoading ? "Processing..." : "Create PG"}
        </Button>
      </Box>
    </TabContext>
  );
};

export default PgOrder;
